/** Placa antiga (ABC1234) ou Mercosul (ABC1D23) — legacy/fixe-link-2 views/invite_goflashwash.ejs. */
const CAR_PLATE_RE = /^[a-zA-Z]{3}[0-9]{1}[a-zA-Z0-9]{1}[0-9]{2}$/;

export function isValidCarPlate(value: string): boolean {
  return CAR_PLATE_RE.test(value.trim());
}

export function normalizeCarPlate(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7);
}
